import PersonaliseExperience from "../../components/PersonaliseExperience";
import { useState, useEffect } from "react";
import CustomInput from "../../components/CustomInput";
import { CiLocationArrow1 } from "react-icons/ci";
import '../../assets/css/Personalise.css';
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { toast } from "react-toastify";
import Select from 'react-select';
import { saveProfileData } from "../../redux/UserDataSlice";


const Location = () => {
    const navigate = useNavigate();
    const { profileData, accessToken, userId } = useSelector((state) => state.loginInfo);
    const [country, setCountry] = useState('');
    const [street, setStreet] = useState('');
    const [city, setCity] = useState('');
    const [stateName, setStateName] = useState('');
    const [zipcode, setZipcode] = useState('');
    const location = useLocation();
    const avatarName = location.state?.inputValue;
    const dispatch = useDispatch();

    const usStates = [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
        "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
        "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "NJ", "New Jersey",
        "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
        "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
        "Wisconsin", "Wyoming", 'Delhi'
    ];
    const [errors, setErrors] = useState({
        country: '',
        street: '',
        city: '',
        stateName: '',
        zipcode: '',
    });
    const [currentLocation, setCurrentLocation] = useState();

    useEffect(() => {
        if (profileData?.baseProfile) {
            setCountry(profileData?.baseProfile?.country || '');
            setStreet(profileData?.baseProfile?.street || '');
            setCity(profileData?.baseProfile?.city || '');
            setStateName(profileData?.baseProfile?.state || '');
            setZipcode(profileData?.baseProfile?.zipcode || '');
        }
    }, [profileData]);

    const validateField = (name, value) => {
        let error = '';

        if (!value) {
            error = `${name} is required`;
        } else if (name === 'zipcode' && !/^\d{5}$/.test(value)) {
            error = 'Zipcode must be 5 digits';
        }

        setErrors(prev => ({ ...prev, [name]: error }));
    };

    const isFormValid =
        Object.values(errors).every(err => err === '') &&
        country && street && city && stateName && zipcode;


    const fetchProfileData = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.PLAYER_PROFILE}?id=${userId}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });

            if (result?.data?.baseProfile) {
                dispatch(saveProfileData(result?.data));
            }
        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
    };

    const onNavigateButton = () => {
        const data = {
            country,
            street,
            city,
            state: stateName,
            zipcode,
            longitude: "77.4376",
            latitude: "28.6260"
        };

        const fetchApi = async () => {
            try {
                const result = await apiHandler({
                    url: endpoint.EDIT_PROFILE,
                    method: 'POST',
                    data: data,
                    authToken: accessToken?.accessToken,
                });
                if (result.data && !result?.data?.error_description) {
                    fetchProfileData();
                    navigate('/sportexperience');
                    toast.success("Updated Successfully");
                } else {
                    toast.error("Please Try Again. Profile not updated.");
                }
            } catch (error) {
                console.error(error);
                toast.error("Something went wrong. Try again.");
            }
        };
        fetchApi();
    };

    const getLocationName = async (lat, lng) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === 'OK') {
                let street = '';
                let city = '';
                let state = '';
                let country = '';
                let zipcode = '';

                for (const result of data.results) {
                    const components = result.address_components;

                    let streetNumber = '';
                    let route = '';

                    components.forEach(component => {
                        if (component.types.includes('street_number')) {
                            streetNumber = component.long_name;
                            streetNumber = component.long_name;
                        }
                        if (component.types.includes('route')) {
                            route = component.long_name;
                        }
                        if (component.types.includes('locality')) {
                            city = component.long_name;
                        }
                        if (component.types.includes('administrative_area_level_1')) {
                            state = component.long_name;
                        }
                        if (component.types.includes('postal_code')) {
                            zipcode = component.long_name;
                        }
                        if (component.types.includes('country')) {
                            country = component.long_name;
                        }
                    });

                    if (streetNumber && route) {
                        street = `${streetNumber} ${route}`;
                        break; // stop after finding the first valid street
                    }
                }

                const location = { street, city, state, zipcode, country };
                return location;
            } else {
                console.error('Geocoding error:', data.status);
                return null;
            }
        } catch (error) {
            console.error('Error fetching location:', error);
            return null;
        }
    };

    useEffect(() => {
        if (navigator?.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    getLocationName(latitude, longitude)
                        .then((location) => {
                            setCurrentLocation(location);
                        });
                },
                (error) => {
                    console.error('Error fetching location:', error);
                }
            );
        }
    }, []);


    const onCurrentLocation = () => {
        setCountry(currentLocation.country || '');
        setStreet(currentLocation.street || '');
        setCity(currentLocation?.city || '');
        setStateName(currentLocation?.state || '');
        setZipcode(currentLocation?.zipcode || '');
    };

    const stateOptions = usStates.map((state) => ({
        value: state,
        label: state
    }));



    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <PersonaliseExperience
                title={'Choose Your Location'}
                style={{ width: '66.66%' }}
                avatarName={avatarName}
                data={
                    <>
                        <div className="personalise-location-txt pt-3" onClick={() => onCurrentLocation()} >
                            <CiLocationArrow1 style={{ marginRight: '15px' }} />
                            Use my current location
                        </div>
                        <div className="personalise-address-txt pt-4">Add Address Manually</div>
                        <div className="row">
                            <div className="col-lg-6">
                                <CustomInput
                                    placeholder="Country"
                                    type="text"
                                    value={country}
                                    onChange={(e) => {
                                        setCountry(e.target.value);
                                        validateField('country', e.target.value);
                                    }}
                                />
                                {errors.country && <small className="text-danger">{errors.country}</small>}
                            </div>
                            <div className="col-lg-6">
                                <CustomInput
                                    placeholder="Street address"
                                    type="text"
                                    value={street}
                                    onChange={(e) => {
                                        setStreet(e.target.value);
                                        validateField('street', e.target.value);
                                    }}
                                />
                                {errors.street && <small className="text-danger">{errors.street}</small>}
                            </div>
                            <div className="col-lg-6">
                                <CustomInput
                                    placeholder="City"
                                    type="text"
                                    value={city}
                                    onChange={(e) => {
                                        setCity(e.target.value);
                                        validateField('city', e.target.value);
                                    }}
                                />
                                {errors.city && <small className="text-danger">{errors.city}</small>}
                            </div>
                            <div className="col-lg-6 mt-4">
                                <Select
                                    options={stateOptions}
                                    value={stateOptions.find(option => option.value === stateName)}
                                    onChange={(selectedOption) => {
                                        const value = selectedOption?.value || '';
                                        setStateName(value);
                                        validateField('stateName', value);
                                    }}
                                    placeholder="Select State"
                                    classNamePrefix="react-select"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            border: '1.5px solid #ddd'
                                        })
                                    }}
                                />
                                {errors.stateName && <small className="text-danger">{errors.stateName}</small>}
                            </div>
                            <div className="col-lg-6">
                                <CustomInput
                                    placeholder="Zip code"
                                    type="text"
                                    value={zipcode}
                                    onChange={(e) => {
                                        setZipcode(e.target.value);
                                        validateField('zipcode', e.target.value);
                                    }}
                                />
                                {errors.zipcode && <small className="text-danger">{errors.zipcode}</small>}
                            </div>
                        </div>
                        <div className="pt-4" onClick={isFormValid ? onNavigateButton : null}>
                            <CustomButton
                                buttonText={'Next'}
                                className='border'
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    borderRadius: '12px',
                                    background: isFormValid ? '#006FFD' : '#cccccc',
                                    color: '#FFFFFF',
                                    cursor: isFormValid ? 'pointer' : 'not-allowed'
                                }}
                                disabled={!isFormValid}
                            />
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default Location;
